import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function ArrowRow({ toggleDrawer, title, path, color, icon }) {
  const history = useHistory();
  return (
    <Button
      variant="contained"
      color={color ? color : "accent"}
      startIcon={icon ? icon : null}
      endIcon={<ArrowForwardIosIcon />}
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        height: "47px",
        fontSize: "17px",
      }}
      onClick={() => (path ? history.push(path) : "")}
    >
      {title}
    </Button>
  );
}
